import { render } from "./TenWeekOrders.vue?vue&type=template&id=5ac864c8"
import script from "./TenWeekOrders.vue?vue&type=script&lang=ts"
export * from "./TenWeekOrders.vue?vue&type=script&lang=ts"
script.render = render

export default script